// 二级品牌馆配置 链上沽上
export default {
  'tjnfr.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001683249686',
      storeName: '链上沽上',
      microHost: 'tjnfr-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001683249686',
      storeName: '链上沽上',
      microHost: 'tjnfr-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001683249686',
      storeName: '链上沽上',
      microHost: 'tjnfr-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001683249686',
      storeName: '链上沽上',
      microHost: 'tjnfr-brand.ubanquan.cn'
    }
  }
};